import { useMainStore } from "../../pinia/main";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive } from "vue";
export default {
  name: "AccountSecurity",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      isHasPassword: false,
      tabsIndex: 0,
      comps: [{
        label: "密码设置",
        name: "Setpwd"
      }, {
        label: "账户注销",
        name: "Unsubscribe"
      }]
    });
    onMounted(() => {
      checkHasPassword();
    });
    const checkHasPassword = async () => {
      var isHasPassword = await globalProperties.$api.checkHasPassword();
      data.isHasPassword = isHasPassword;
      data.comps[0].label = isHasPassword ? "修改密码" : "密码设置";
      data.comps[0].name = isHasPassword ? "EditPwd" : "Setpwd";
      // if (isHasPassword) {
      //   data.comps.unshift({
      //     label: "忘记密码",
      //     name: "ForgetAccountPwd",
      //   });
      // }
    };
    const changeTabs = index => {
      data.tabsIndex = index;
    };
    return {
      mainStore,
      data,
      changeTabs
    };
  }
};